const errorServiceGeneric = `Por el momento no podemos completar tu solicitud,
    intenta más tarde.`;

export default { errorServiceGeneric };
